import { group } from 'd3';
function getScaleBandwidth(scale) {
  return 'bandwidth' in scale ? scale.bandwidth() : 0;
}
export function getBarGroups(data, groupScale, xScale, yScale, colorScale, groupAccessor, valueAccessor, colorAccessor, xAccessor) {
  const barWidth = getScaleBandwidth(groupScale);
  const groups = group(data, groupAccessor);
  const barGroups = Array.from(groups).map((_ref, i) => {
    let [key, entries] = _ref;
    return {
      index: i,
      x0: groupScale(key),
      bars: entries.map((d, j) => {
        var _yScale;
        return {
          index: j,
          key: key,
          datum: d,
          width: barWidth,
          xValue: xAccessor(d) || 0,
          yValue: valueAccessor(d) || 0,
          x: xScale(xAccessor(d)) || 0,
          y: yScale(valueAccessor(d)) || 0,
          label: colorAccessor(d) || '',
          color: colorScale(colorAccessor(d)),
          height: yScale.range()[0] - ((_yScale = yScale(valueAccessor(d))) !== null && _yScale !== void 0 ? _yScale : yScale.range()[0])
        };
      })
    };
  });
  return barGroups;
}